import { Component, forwardRef, Host, Input, OnInit, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { inputMgsErrs } from 'src/app/validators/message-validation';
import { FormComponentControl } from '../form-component-control';

@Component({
  selector: 'app-input-text-group',
  templateUrl: './input-text-group.component.html',
  styleUrls: ['./input-text-group.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputTextGroupComponent),
      multi: true
    }
  ]
})
export class InputTextGroupComponent extends FormComponentControl implements OnInit {
  @Input() groupClass = 'mb-3';
  @Input() labelClass = 'mb-1';
  @Input() inputClass = '';
  @Input() iconClass: 'icon-user' | 'icon-iphone';
  @Input() isDisabled: boolean;
  @Input() numberOnly: boolean;
  @Input() maxlength: string;
  @Input() errors = inputMgsErrs.mobilePhone;

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer,
  ) {
    super(cc);
  }

  ngOnInit() {
    this.checkInitialControl();
  }

  onBlur() {
    this._isFocus = false;
    this._isBlur = true;
  }
}
